import * as tslib_1 from "tslib";
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import getConsumerMailboxOptions from '../services/getConsumerMailboxOptions';
import getCASMailboxOptions from '../services/getCASMailboxOptions';
import { isConsumer } from 'owa-session-store';
export default action('initPopImapConfiguration')(function initPopImapConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var casMailboxOptions, consumerMailboxOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (store.popEnabled) {
                        // If we already have the PopImap configuration, we won't get it again
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getCASMailboxOptions()];
                case 1:
                    casMailboxOptions = _a.sent();
                    store.popSettings = casMailboxOptions.ExternalPopSettings;
                    store.imapSettings = casMailboxOptions.ExternalImapSettings;
                    store.smtpSettings = casMailboxOptions.ExternalSmtpSettings;
                    if (!isConsumer()) return [3 /*break*/, 3];
                    return [4 /*yield*/, getConsumerMailboxOptions()];
                case 2:
                    consumerMailboxOptions = _a.sent();
                    store.popEnabled = consumerMailboxOptions.PopEnabled;
                    store.popMessageDeleteEnabled = consumerMailboxOptions.PopMessageDeleteEnabled;
                    return [3 /*break*/, 4];
                case 3:
                    store.popEnabled = casMailboxOptions.PopEnabled;
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initPopImapConfiguration.js.map